import routes from './login.routes';

export const loginModule = {
    routes
};